import React, { useState } from 'react';
import HomeChart from './HomeChart';

const SecondHome = () => {

    const [theme] = useState("green");

    const primary = theme === "green" ? "#16a34a" : "#0f62fe";
    const accent = theme === "green" ? "#0ea56a" : "#0b84ff";

    const hexToRgba = (hex, alpha = 1) => {
        const h = hex.replace("#", "");
        const bigint = parseInt(h, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r},${g},${b},${alpha})`;
    };

    return (
        <section className="second-home">
            <div
                className="split-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "2rem",
                    padding: "2rem",
                    width: "100%",
                    boxSizing: "border-box",
                    position: "relative",
                    bottom: "1vh",
                }}
            >
                <div
                    className="left-pane"
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "320px",
                        position: "relative",
                        bottom: "80px",
                    }}
                >
                    <img style={{width: "75%"}} src={require("../assets/img/btc3.png")} />
                    </div>

                <div
                    className="right-pane"
                    style={{ flex: 1, minHeight: "320px", display: "flex", flexDirection: "column", justifyContent: "center", position: "relative", bottom: "50px" }}
                >
                    <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.75rem" }}>
                        <span style={{ color: "#fff" }}>Trade Crypto with </span>
                        <span style={{ color: primary }}>Confidence</span>
                    </h2>
                    <p style={{ margin: "0 0 1rem", color: "#777", lineHeight: 1.5 }}>
                        Access fast, secure trading tools and expert guidance. We help traders of all levels
                        navigate the market with transparent fees, advanced analytics, and 24/7 support.
                        Take control of your financial journey with powerful tools, real-time market data,
                        and a secure environment built for both beginners and professionals.
                        Start exploring, trade with confidence, and unlock your full potential in the markets.
                    </p>

                    <ul style={{ margin: "0 0 1.25rem", paddingLeft: "1.25rem", color: "#555", listStyle: "none" }}>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> Real-time market data and charting</li>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> Risk management tools and automated orders</li>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> Dedicated support and personalized strategies</li>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> 24/7 Support</li>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> Money transaction guarantee</li>
                        <li style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}><span style={{ color: primary }}>✓</span> Order placement strategies planning</li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default SecondHome;